import React, { Component } from 'react';
import swal from 'sweetalert';
import SDIConstants from '../SDIConstants';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import * as MenuAction from '../actions/MenuAction';
import * as ContainerBarCodeAction from '../actions/ContainerBarCodeAction';
import ContainerBarCodeStore from '../stores/ContainerBarCodeStore';
import { withTranslation, Trans } from 'react-i18next';
import PDFPreviewComponent from './PDFPreviewComponent';
import Select from 'react-select';
import { saveAs } from 'file-saver';
import { detect } from 'detect-browser';

let currentPagePath;

class ContainerBarCodeComponent extends Component {
    constructor(props) {
        super(props);
        this.pageLoadResponse = this.pageLoadResponse.bind(this);
        this.printLabelResponse = this.printLabelResponse.bind(this);
        this.displayPDFResponse = this.displayPDFResponse.bind(this);

        this.state = {
            CntPrinterOptions: [],
            NbrOfPages: "",
            CntPrinterDDValue: "",
            isPrintSuccess: false,
            previousBarCode: 0,
            isFavorited: false,
            base64URL: ""
        }
    }
    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let CribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        if (CribID == null || CribID == undefined || CribID == "" || CribID == " ") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        else {
            currentPagePath = this.props.location.pathname;
            currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            let getFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            ContainerBarCodeAction.getCurrentFavPage(getFavPageBO);
            this.pageLoad()
        }
        ContainerBarCodeStore.on('pageLoadResponse', this.pageLoadResponse);
        ContainerBarCodeStore.on('printLabelResponse', this.printLabelResponse);
        ContainerBarCodeStore.on('displayPDFResponse', this.displayPDFResponse);
        ContainerBarCodeStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        ContainerBarCodeStore.on('favpage', this.loadFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ContainerBarCodeStore.removeListener('pageLoadResponse', this.pageLoadResponse);
        ContainerBarCodeStore.removeListener('printLabelResponse', this.printLabelResponse);
        ContainerBarCodeStore.removeListener('displayPDFResponse', this.displayPDFResponse);
        ContainerBarCodeStore.removeListener('updateFavPage', this.updateFavPageResponse);
        ContainerBarCodeStore.removeListener("favpage", this.loadFavPageResponse);

    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ContainerBarCodeStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (ContainerBarCodeStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ContainerBarCodeStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ContainerBarCodeStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };

    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Print Container Bar Code Labels",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ContainerBarCodeAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ContainerBarCodeAction.deleteFavPage(deleteFavPageBO)
        }
    };

    pageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ContainerBarCodeAction.pageLoad()
    }

    pageLoadResponse = () => {
        
        let cntPrinter = JSON.parse(ContainerBarCodeStore.pageLoadResponse);
        let PrinterNames = cntPrinter[0].PrinterName;
        let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        let locPrinterNames = [];
        let PrinterValues = PrinterNames.split("|")
        if (PrinterValues.length > 0) {
            PrinterValues.map((val, index) => {
                if (val.toLowerCase().includes(cribID.toLowerCase().trim()) && val.toLowerCase().includes("bol")) {
                    let locPrinters = {
                        value: val,
                        label: val.replace(cribID, ""),
                    }
                    locPrinterNames.push(locPrinters);
                };
            });
        }
        this.setState({ CntPrinterOptions: locPrinterNames });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };

    handleCntPrinterDD = (e) => {
        
        let locPrinters = {
            value: e.value,
            label: e.label
        }
        this.setState(
            { CntPrinterDDValue: locPrinters });
    }

    onChange = (e) => {
        const re = SDIConstants.NoOnlyZeroRegex;
        const reg = /^[0]+$/ /*regex that checks for only zero*/
        if (e.target.value === '') {
            this.setState({ NbrOfPages: '' });
        }
        else if (re.test(e.target.value)) {
            this.setState({ NbrOfPages: e.target.value.trim() });
        }
        else if (reg.test(e.target.value)) {
            this.setState({ NbrOfPages: '' });
        }
    }

    onClear = () => {
        this.setState({ NbrOfPages: "", CntPrinterDDValue: "", isPrintSuccess: false });
    }

    displayPDFResponse = () => {
        let cntPDF = ContainerBarCodeStore.cntBarCodePDF;
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        const browser = detect();
        const isSafari = browser && browser.name === 'safari';

        if (isSafari) {
            ;
            let sliceSize = 512
            const byteCharacters = atob(cntPDF.split(',')[1]);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: "application/pdf" });
            saveAs(blob, "Container Bar Code Labels Report");

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "The report is downloaded successfully"
            })
            this.setState({ isPrintSuccess: false })

        }
        else {
            $('#pdfPreview').modal('show');
            this.setState({ base64URL: cntPDF, isPrintSuccess: false })
        }
    }

    //handleClose = () => {
    //    this.pageLoad()
    //    this.setState({ NbrOfPages: "", CntPrinterDDValue: "", isPrintSuccess: false, base64URL:"" });
    //}

    printLabelResponse = () => {
        let printCntResponse = JSON.parse(ContainerBarCodeStore.printResponse);
        let printResult = printCntResponse.PrintResultDT;
        let result = printResult[0].Status;
        let lastBarcode = printCntResponse.LastBarCodeDT;
        let preBarcode = parseInt(lastBarcode[0].END_BAR_CODE);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (result !== undefined && result !== null && result.toUpperCase().includes('SUCCESS')) {
            $('#SuccessPopUp').modal('show');
            this.setState({
                isPrintSuccess: true,
                previousBarCode: preBarcode
            });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue, contact SDI customer care."
            })
        }
    }

    printLabel = (e) => {
        let printCntObj = {
            UserID: CookieService.getLocalStorageValues("Session_UserID"),
            NbrOfPages: this.state.NbrOfPages,
            printerName: this.state.CntPrinterDDValue.value,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ContainerBarCodeAction.printLabel(printCntObj)
    }

    displayPDF = (e) => {
        let cntPDFObj = {
            NbrOfPages: this.state.NbrOfPages,
            previousBarCode: this.state.previousBarCode,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ContainerBarCodeAction.displayPDF(cntPDFObj)
    }


    render() {
        return (
            <div>
                <div className="container-fluid container-margin content-section-top">
                    <div className="row">
                        <div className="col-md-12 page-heading mb-3">
                            <h5 className="page-title"><Trans>Print container bar code labels</Trans></h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        {/*Middle layout starts here*/}
                        <div className="col-md-12">
                            <div className="row justify-content-center custom-height align-items-center">
                                <div className="col-lg-6 col-xl-4 col-md-6">
                                    <div className="container shadow rounded-3 px-5 py-4">
                                        {/*forms*/}
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label catalog-label text-nowrap" htmlFor="pages"><Trans>Number of pages</Trans></label>
                                                <input type="text" className="form-control" id="pages" placeholder="Enter count" maxlength="5" value={this.state.NbrOfPages} onChange={(e) => this.onChange(e)} />
                                            </div>
                                            <div className="col-md-12 mb-5">
                                                <label className="form-label catalog-label text-nowrap" htmlFor="printer"><Trans>Printer</Trans></label>
                                                <Select
                                                    id="CntPrinterDD"
                                                    name="CntPrinterDD"
                                                    onChange={(e) => this.handleCntPrinterDD(e)}
                                                    value={this.state.CntPrinterDDValue}
                                                    options={this.state.CntPrinterOptions}
                                                    classNamePrefix="react-select"
                                                />
                                            </div>
                                            <div className="col-md-12">
                                                <div className="d-grid d-md-flex justify-content-md-between align-items-center grid-resp-style">
                                                    <div>
                                                        {this.state.isPrintSuccess ? <button className="mb-2 bg-white custom-border px-2 py-1 primary-btn-responsive" type="button" onClick={() => this.displayPDF()}><img className="pdf-icon-width" src="images/pdf-icon.svg" alt="print-pdf" title="Print as PDF" /></button> : null}
                                                    </div>
                                                    <div>
                                                        {this.state.NbrOfPages == "" && this.state.CntPrinterDDValue == "" ? null : <button className="btn btn-dark-grey font-14 font-medium mr-2 px-4 primary-btn-responsive mb-2" data-dismiss="modal" onClick={() => this.onClear()}>Clear</button>}
                                                        <button className="btn btn-custom-primary font-14 font-medium px-4 primary-btn-responsive mb-2" disabled={this.state.NbrOfPages == "" || this.state.CntPrinterDDValue == "" ? true : false} onClick={() => this.printLabel()} >Print labels</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*forms*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Middle layout ends here*/}

                        {/*Modal Starts here*/}
                        <div className="modal fade success" tabIndex={-1} role="dialog" id="SuccessPopUp" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered custom-success-width" role="document">
                                <div className="modal-content py-2">
                                    {/*Success Starts here*/}
                                    <div className="modal-body pb-2">
                                        <div className="row">
                                            <div className="col-12  col-sm-12  col-md-12 col-lg-12 text-center">
                                                <img className="mb-2" src="images/tick.svg" alt="tick" />
                                                <h5 className="mb-2 font-16 font-bold color-light-black"><Trans>Success</Trans></h5>
                                                <p className="mb-0 font-13 font-regular color-light-black"><Trans>The labels have been successfully printed!</Trans></p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*Success end here*/}
                                    <div className="modal-footer border-0 d-flex justify-content-center pt-2">
                                        <button className="btn btn-custom-primary font-15 font-medium mr-2 mb-2 px-4 py-2" data-dismiss="modal">OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Modal Ends here*/}
                        <div className="modal orderstatus-popup" id="pdfPreview" data-backdrop="static" data-keyboard="false">
                            <PDFPreviewComponent key={1} base64URL={this.state.base64URL} PdfPage="3" pdfTitle="Container bar code labels report" {...this.props} />
                        </div>


                    </div>
                </div>
            </div>)
    };
}
export default withTranslation()(ContainerBarCodeComponent);